module.exports = __webpack_public_path__ + "static/kaoqin-fdc9929a24068dc2a339cea415ba4f45.png";